import AnimatedSection from './AnimatedSection';
import { queryClosestParent } from '../utils/html';

export default class extends AnimatedSection {
    constructor(m) {
        super(m);

        this.secondaryCol = this.$('secondaryCol')
        this.$aside = this.$('aside')
    }

    initTl() {
        this.scrollTl = new TimelineMax({})
        this.scrollTl.fromTo(this.secondaryCol, 1, { y: 0 }, { y: this.secondaryColDiff, ease: Linear.easeNone }, 0)
        for(let aside of Array.from(this.$aside)) {
            let parent = this.parent('infos', aside)
            let parentHeight = parent.offsetHeight;
            let diff = parentHeight - aside.offsetWidth

            this.scrollTl.fromTo(aside, 1, { y: diff }, { y: 0, ease: Linear.easeNone }, 0)
        }
        this.scrollTl.pause()
    }

    compute() {
        super.compute()

        TweenMax.set([this.secondaryCol, this.$aside], { clearProps: 'all' }) // Make sure to reset initial state before computing data
        this.scrollEnd = this.scrollStart + this.BCR.height
        this.secondaryColBCR = this.secondaryCol.getBoundingClientRect()
        this.secondaryColDiff = this.BCR.height - this.secondaryColBCR.height - (this.secondaryColBCR.top - this.BCR.top)
    }
}
